module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol.js
// module id = 883
// module chunks = 0